import { CxServiceUnavailableError } from '@/classes/error.class';
import http from '@/plugins/axios.instance';

const logoutUrl = process.env.VUE_APP_LOGOUT_URL || '/frontend/logout';

const logout = async () => {
  try {
    await http.post(logoutUrl, null, { withCredentials: true });
  } catch (error) {
    throw new CxServiceUnavailableError(error);
  }
};

export default logout;